/* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
export default {
  data () {
    return {
      keyIdx: 0,
      isLoading: false,
      chartRows: [],
      chartOptions: {
        pointSize: 14,
        legend: 'none',
        backgroundColor: '#fafafa',
        vAxis: {
          textStyle: {
            color: '#58595b',
            fontSize: 10
          }
        },
        hAxis: {
          textStyle: {
            color: '#58595b',
            fontSize: 10
          }
        },
        series: {
          0: {color: '#397EF5'}
        },
        height: 350,
        chartArea: {
          left: 30,
          right: 0,
          top: 25,
          bottom: 20
        },
        animation: {
          duration: 300,
          easing: 'out',
          startup: true
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/charts.js